export const DataLocales = [
    {
        value: "ar",
        label: "عربى",
    },
    {
        value: "zh-CN",
        label: "Chinese - China",
    },
    {
        value: "en",
        label: "English",
    },
    {
        value: "en-US",
        label: "English - United States",
    },
    {
        value: "en-150",
        label: "English - Europe",
    },
    {
        value: "en-AU",
        label: "English - Australia",
    },
    {
        value: "en-BE",
        label: "English - Belgium",
    },
    {
        value: "en-CA",
        label: "English - Canada",
    },
    {
        value: "en-GB",
        label: "English - Great Britain",
    },
    {
        value: "en-HK",
        label: "English - Hong Kong SAR China",
    },
    {
        value: "en-IN",
        label: "English - India",
    },
    {
        value: "en-IE",
        label: "English - Ireland",
    },
    {
        value: "en-MY",
        label: "English - Malaysia",
    },
    {
        value: "en-NZ",
        label: "English - New Zealand",
    },
    {
        value: "en-PH",
        label: "English - Philippines",
    },
    {
        value: "en-SG",
        label: "English - Singapore",
    },
    {
        value: "en-ZA",
        label: "English - South Africa",
    },
    {
        value: "fr",
        label: "French",
    },
    {
        value: "fi",
        label: "Finnish",
    },
    {
        value: "fr-CA",
        label: "French - Canada",
    },
    {
        value: "fr-CH",
        label: "French - Switzerland",
    },
    {
        value: "da",
        label: "Danish",
    },
    {
        value: "de",
        label: "German",
    },
    {
        value: "de-at",
        label: "German - Austria",
    },
    {
        value: "de-ch",
        label: "German - Switzerland",
    },
    {
        value: "el",
        label: "Greek",
    },
    {
        value: "es",
        label: "Spanish",
    },
    {
        value: "es-US",
        label: "Spanish - America",
    },
    {
        value: "id",
        label: "Indonesian",
    },
    {
        value: "it",
        label: "Italiano",
    },
    {
        value: "ja",
        label: "Japanese",
    },
    {
        value: "km",
        label: "Khmer",
    },
    {
        value: "nb",
        label: "Norwegian",
    },
    {
        value: "pa-in",
        label: "Punjabi (India)",
    },
    {
        value: "pt",
        label: "Portuguese",
    },
    {
        value: "pt-br",
        label: "Portuguese - Brazil",
    },
    {
        value: "sr",
        label: "Serbian",
    },
    {
        value: "th",
        label: "Thai",
    },
    {
        value: "vi",
        label: "Vietnamese",
    },
];
//# sourceMappingURL=locales.js.map